import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import groupBy from 'lodash/groupBy.js';
import PendoButton from '../../button/pendo-button.vue.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'PendoGuideProgressCell',
  components: {
    PendoIcon,
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  inject: ['$table'],
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isShowingAllProgress: false
    };
  },
  computed: {
    toggleAllProgressLabel() {
      if (this.isShowingAllProgress) {
        return 'show less';
      }
      return `+ ${Math.abs(this.row.totalSteps - 9)} more`;
    },
    eventsByStepIndex() {
      if (!this.row.s) {
        return {};
      }
      return groupBy(this.row.s, 'stepIndex');
    },
    visibleStepCount() {
      if (this.isShowingAllProgress) {
        return this.row.totalSteps;
      }
      return Math.min(this.row.totalSteps, 9);
    },
    progress() {
      if (!this.row.s) {
        return;
      }
      return Array.from({
        length: this.visibleStepCount
      }, (x, index) => {
        const stepIndex = index + 1;
        let props;
        if (this.eventsByStepIndex[stepIndex]) {
          const progressEventTypes = ['guideAdvanced', 'guideDismissed', 'guideSnoozed', 'guideSeen', 'guideTimeout'];
          const mostRecentEventForStep = [...this.eventsByStepIndex[stepIndex]].filter(event => progressEventTypes.includes(event.type)).sort((a, b) => b.browserTime - a.browserTime)[0];
          props = {
            guideAdvanced: {
              label: mostRecentEventForStep.isWalkthrough ? 'Advanced' : 'Action Taken',
              fill: '#128297'
            },
            guideDismissed: {
              label: 'Closed',
              fill: '#6A6C75'
            },
            guideSnoozed: {
              label: 'Snoozed',
              fill: '#9A9CA5'
            },
            guideSeen: {
              label: 'Displayed',
              fill: '#128297'
            },
            guideTimeout: {
              label: 'Display Error',
              fill: '#DB1111'
            }
          }[mostRecentEventForStep.type];
        } else {
          props = {
            label: 'Not Seen',
            stroke: '#BABCC5',
            fill: '#FFFFFF'
          };
        }
        let content = `Step ${stepIndex} of ${this.row.totalSteps}`;
        if (this.row.stepAppNames) {
          content += `<br/>App: ${this.row.stepAppNames[index]}`;
        }
        content += `<br/>Status: ${props.label}`;
        return _objectSpread2(_objectSpread2({}, props), {}, {
          tooltip: {
            content,
            html: true,
            arrow: true
          },
          icon: {
            size: 12,
            type: 'circle',
            strokeWidth: 3,
            fill: props.fill,
            stroke: props.stroke || props.fill
          }
        });
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-progress-cell.vue2.js.map
